module.exports = __webpack_public_path__ + "c99b4b2221f7c752c2c271ae73aadfd3.svg";